import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog.tsx";
import { Button } from "@/components/ui/button.tsx";
import { MessageSquareIcon } from "lucide-react";
import { MentorshipFeedback } from "@/lib/api/mentorships.ts";

interface MoreDetailsProps {
  data: MentorshipFeedback["ratingList"][number];
}

export function MoreDetails({ data }: MoreDetailsProps) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="ghost" size="icon" className="mx-auto flex">
          <MessageSquareIcon className="h-5 w-5" />
        </Button>
      </DialogTrigger>
      <DialogContent className="flex max-h-[90vh] flex-col overflow-hidden p-0 sm:max-w-[425px]">
        <DialogHeader className="border-b border-neutral-200 p-6 pb-4">
          <DialogTitle className="text-lg font-semibold text-indigo-500">
            Survey Responses
          </DialogTitle>
        </DialogHeader>
        <div className="overflow-y-auto">
          <div className="px-6 pb-6">
            <div className="space-y-6">
              {data?.responses?.map((response, index) => (
                <div
                  key={index}
                  className="rounded-lg border border-neutral-200 bg-neutral-50 p-4"
                >
                  <div className="space-y-2">
                    <div className="space-y-1">
                      <p className="text-sm font-medium uppercase tracking-wide text-indigo-500">
                        Question {index + 1}
                      </p>
                      <p className="text-sm font-medium text-gray-900">
                        {response?.question || "N/A"}
                      </p>
                    </div>
                    <div className="space-y-1">
                      <p className="text-sm font-medium uppercase tracking-wide text-indigo-500">
                        Response
                      </p>
                      <p className="text-sm text-gray-700">
                        {response?.response || "N/A"}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
